import { Field } from "@ui/components/forms/field/Field";
import type { FormControlProps } from "@ui/components/forms/form-control/FormControl";
import { FormControl } from "@ui/components/forms/form-control/FormControl";
import { FormErrorMessage } from "@ui/components/forms/form-control/FormError";
import { FormLabel } from "@ui/components/forms/form-control/FormLabel";
import { Input } from "@ui/components/forms/input/Input";
import { typeMap } from "./constants";
import type { Field as FieldType } from "../../types";

type Props = {
    error?: string;
    touched: boolean;
    label: string;
    display?: FormControlProps["display"];
    fieldType: Exclude<FieldType, "password">;
    isDisabled?: boolean;
};

export const BaseField = ({ error, label, touched, display, fieldType, isDisabled }: Props) => {
    const { name, type, label: fieldLabel } = typeMap[fieldType];

    return (
        <FormControl isRequired isInvalid={(!!error && touched) as boolean} display={display}>
            <FormLabel htmlFor={name} id={fieldLabel}>
                {label}
            </FormLabel>
            <Field
                isDisabled={isDisabled}
                as={Input}
                id={name}
                name={name}
                type={type}
                aria-labelledby={fieldLabel}
            />
            <FormErrorMessage>{error?.toString()}</FormErrorMessage>
        </FormControl>
    );
};
